/* eslint dot-notation: "off" */
// @flow

import paramsList from 'constants/paramsList';
import { filters as defaultFilters } from 'core/config';

type Props = {
  search: any,
  placeName?: string
}

const searchEventParams = ({ search, placeName }: Props) => {
  const eventParams = {};
  const filters = {};
  defaultFilters.forEach(i => { filters[i.counts_param] = i.data; });
  const filterKeys = {
    category_ids: 'categories',
    region_ids: 'regions',
    industry_ids: 'industries',
    work_type_ids: 'work_types',
    entry_level_ids: 'entry_levels',
    job_language_ids: 'job_languages',
    number_employees_group_ids: 'number_employees_groups'
  };

  const getQueryData = (paramKey: string, value: string) => {
    if (search[paramKey] && value) {
      eventParams['query'] = search[paramKey];
    }
  };

  const getStringData = (paramKey: string, value: string) => {
    if (search[paramKey] && value) {
      eventParams[paramKey] = search[paramKey];
    }
  };

  const getArrayData = (paramKey: string, paramValue: Array<any>) => {
    if (paramValue) {
      eventParams[paramKey] = paramValue;
      eventParams[paramsList[paramKey].eventParam] = paramValue.map(item => filters[filterKeys[paramKey]].find(({ id }) => id === +item).name);
    }
  };

  const getArraySingleData = (paramKey: string, paramValue: Array<any>) => {
    if (paramValue) {
      eventParams[paramKey] = paramValue.toString();

      if (paramKey === 'distance') {
        eventParams[paramKey] = paramValue.toString();
      } else if (paramKey === 'place_id') {
        eventParams[paramKey] = paramValue.toString();
        eventParams['place_name'] = placeName;
      } else {
        eventParams[paramKey] = paramValue;
        eventParams[paramsList[paramKey].eventParam] = paramValue.map(item => filters[filterKeys[paramKey]].find(({ id }) => id === +item).name);
      }
    }
  };

  Object.keys(search).forEach(paramKey => {
    const { type } = paramsList[paramKey];

    if (type === 'query') getQueryData(paramKey, search[paramKey]);
    if (type === 'string') getStringData(paramKey, search[paramKey]);
    if (type === 'array') getArrayData(paramKey, search[paramKey]);
    if (type === 'arraySingle') getArraySingleData(paramKey, search[paramKey]);
  });

  return eventParams;
};

searchEventParams.defaultProps = {
  placeName: ''
};

export default searchEventParams;
